import React from 'react'
import Button from '../Button/Button'

class LoginBlock extends React.Component {

    render() {
        return (
            <div>
                <div onClick={() => this.props.openLoginModal({})}>
                    <Button>Login</Button>
                </div>
            </div>
        )
    }
}

export default LoginBlock
